import { render } from "./ClienteFactura.vue?vue&type=template&id=44b9098b&scoped=true"
import script from "./ClienteFactura.vue?vue&type=script&lang=js"
export * from "./ClienteFactura.vue?vue&type=script&lang=js"

import "./ClienteFactura.vue?vue&type=style&index=0&id=44b9098b&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b9098b"]])

export default __exports__